import { Component } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import { DestinationsProviderService } from '../../provider/destinations.provider';
import { SearchDisplayCheck } from '../../provider/searchVisibility';
import * as Constants from '../../provider/Constants';
import { Subscription } from 'rxjs';

/**
 * Generated class for the ParenttabsPage tabs.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'destinations-page',
  templateUrl: 'destinations.html'
})
export class DestinationsPage {

  name = '';
  visible = false;
  loading;
  SearchTypeID = '';

  private jsondata;
  destinations: any;
  searchResultsEnable = false;
  searchparams = '';
  searchresultsSubscription: Subscription;
  searchresultsvacSubscription: Subscription;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private destService: DestinationsProviderService,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    private addtab: SearchDisplayCheck,
    private searchVisibleData: SearchDisplayCheck) {
    this.name = this.navParams.data.ScreenTitle;
    this.SearchTypeID = this.navParams.data.SearchTypeID;
    console.log('Passed params', this.navParams.data);
  }


  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }

  swipeEvent(e) {
    console.log('swiped');
  }

  ionViewDidEnter() {
    this.searchresultsvacSubscription = this.searchVisibleData.searchResultsVacationMessage.subscribe(message => this.gotovacsearchResults(message));
    console.log('Enter view');
    this.getDeals();
    this.presentLoading();
  }

  gotovacsearchResults(message) {
    if (message.searchres === true) {
      if (this.name === Constants.VACATIONS.params.name) {
        if (message.ScreenTitle === 'VACATIONS') {

          this.searchResultsEnable = true;
          this.searchparams = message;
          this.searchVisibleData.changeSearchResForVacVisibility({});
          this.searchresultsSubscription = this.searchVisibleData.searchResultsMessage.subscribe(message => this.gotosearchResults(message));
        }

      }
    }

  }

  gotosearchResults(message) {
    if (message.searchres !== true) {
      this.searchResultsEnable = false;
    }

  }

  ionViewWillLeave() {
    console.log('Leave view');
    this.searchResultsEnable = false;
  }

  getDeals() {
    this.destService.getDestinations({ 'ScreenTitle': this.name, 'SearchTypeID': this.SearchTypeID }).then(data => {

      console.log('status::::' + data.status);
      console.log('data::::' + data.data); // data received by server
      console.log('data::::json' + JSON.parse(data.data));
      this.jsondata = JSON.parse(data.data);

      this.destinations = this.jsondata;
      this.visible = true;
      if (this.loading != null) {
        this.loading.dismiss();
      }

    })
      .catch(error => {

        console.log(error.status);
        console.log(error.error); // error message as string
        console.log(error.headers);
        if (this.loading != null) {
          this.loading.dismiss();
        }

      });
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({

    });

    this.loading.present();

  }

  clickevent(data, i) {

    const destid = data.DestinationID;
    const destname = data.DestinationName;

    console.log('cat subcat' + destid);
    const tabdata = {
      'tabenable': true, 'ScreenTitle': this.navParams.data.ScreenTitle,
      'DestinationID': destid, 'subcatname': destname, 'SearchTypeID': this.navParams.data.SearchTypeID
    };
    this.addtab.addTab(tabdata);
  }

  toggleSection(i) {
    this.destinations[i].open = !this.destinations[i].open;
  }

  toggleItem(i, j) {
    this.destinations[i].SubCategory[j].open = !this.destinations[i].SubCategory[j].open;
  }

  ngOnDestroy() {
    console.log('destionaions ondestroy');
    if (this.searchresultsSubscription != null) {
      this.searchresultsSubscription.unsubscribe();
    }
    this.searchresultsvacSubscription.unsubscribe();
  }

}

